import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="main_footer"
      style={{ backgroundImage: "url(/images/background/footer-bg.jpg)" }}
    >
      <div className="container">
        <div className="footer-top-outer">
          <div className="row">
            {/* About Widget */}
            {/* <div className="col-12 col-md-3">
              <div className="footer_widget footer_about_widget">
                <figure className="footer_widget_logo">
                  <a href="index-2.html">
                    <img src="/images/logo.jpg" alt="Footer Logo" />
                  </a>
                </figure>
                <p>Sai Trupti Cabs is a trusted and customer-focused cab service provider specializing in reliable, comfortable, and affordable travel solutions across Mumbai, Pune, and nearby regions.</p>
                <ul className="footer-info-list">
                  <li>
                    <a href="mailto:booking@saitrupticabs.com">booking@saitrupticabs.com</a>
                  </li>
                  <li>
                    <a href="tel:918390907004">+91 8390907004</a>
                  </li>
                  <li>
                    <a href="tel:919922727744">+91 9922727744</a>
                  </li>
                </ul>
              </div>
            </div> */}

            <div className="col-12 col-md-3">
  <div className="footer_widget footer_about_widget">
    <figure className="footer_widget_logo">
      <a href="index-2.html">
        <img src="/images/logo.jpg" alt="Footer Logo" />
      </a>
    </figure>
    <p>
      Sai Trupti Cabs is a trusted and customer-focused cab service provider specializing in reliable, comfortable, and affordable travel solutions across Mumbai, Pune, and nearby regions.
    </p>
    <ul className="footer-info-list">
      <li>
        <i className="fa fa-envelope text-warning" aria-hidden="true"></i>{" "}
        <a href="mailto:booking@saitrupticabs.com">booking@saitrupticabs.com</a>
      </li>
      <li>
        <i className="fa fa-phone text-warning" aria-hidden="true"></i>{" "}
        <a href="tel:918390907004">+91 8390907004</a>
      </li>
      <li>
        <i className="fa fa-phone text-warning" aria-hidden="true"></i>{" "}
        <a href="tel:919922727744">+91 9922727744</a>
      </li>
    </ul>
  </div>
</div>


            {/* Resources Widget */}
            <div className="col-12 col-md-3">
              <div className="footer_widget footer_resources_widget">
                <h4 className="footer_widget_title">Services</h4>
              <Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-International-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai International Airport Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai One Way Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-Mumbai-Car-Hire"><i className="fa fa-car darkcolor"></i> Pune Mumbai Car Hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Taxi Fare</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Online-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Online Cab Booking</Link>
<Link className="mx-md-2 d-block" to="/Pimpri-Chinchwad-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Baner-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Baner to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Hinjewadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Hinjewadi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pimple-Saudagar-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Pimple Saudagar to Mumbai Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Wakad-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Wakad to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Hadapsar-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Hadapsar to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Kalyani-Nagar-to-Mumbai-Taxi"><i className="fa fa-car darkcolor"></i> Kalyani Nagar to Mumbai Taxi</Link>
<Link className="mx-md-2 d-block" to="/Koregaon-Park-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Koregaon Park to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Kothrud-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kothrud to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Kharadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kharadi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Shivajinagar-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Shivajinagar to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Ertiga-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Ertiga Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Innova-Crysta-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Innova Crysta Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Sedan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Sedan Cab</Link>
<Link className="mx-md-2 d-block" to="/Kondhwa-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kondhwa to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Viman-Nagar-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Viman Nagar to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Katraj-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Katraj to Mumbai Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-Station-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Pune Station to Mumbai Cabs Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-5-Jyotirlinga-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to 5 Jyotirlinga Darshan Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Cab-Fare"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab Fare</Link>
<Link className="mx-md-2 d-block" to="/Pune-Airport-to-Shirdi-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Airport to Shirdi Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Pandharpur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Aurangabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Aurangabad Cab</Link>
  <Link className="mx-md-2 d-block" to="/Navi-Mumbai-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-Airport-to-Pune-City-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune City Cab</Link>
<Link className="mx-md-2 d-block" to="/Swift-Dzire-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-Daily-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Daily Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-Online-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Online Cab</Link>
<Link className="mx-md-2 d-block" to="/Jogeshwari-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Jogeshwari to Pune Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Goregaon-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Goregaon to Pune Cab</Link>
             <Link className="mx-md-2 d-block" to="/Kandivali-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Kandivali to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Vile-Parle-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Vile Parle to Pune Cab Service</Link>

              </div>
            </div>

          



 <div className="col-12 col-md-3">
              <div className="footer_widget footer_newsletter_widget">
                <h4 className="footer_widget_title">Services</h4>


<Link className="mx-md-2 d-block" to="/Bhandup-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Bhandup to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Ghatkopar-to-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Ghatkopar to Pune Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Kurla-to-Pune-Taxi-Service"><i className="fa fa-car darkcolor"></i> Kurla to Pune Taxi Service</Link>
<Link className="mx-md-2 d-block" to="/Powai-Mumbai-Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Powai Mumbai Pune Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Chembur-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Chembur to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Terminal 1,2,3 Mumbai Airport to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Thane-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Thane to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Vikhroli-to-Pune-Cab-Services"><i className="fa fa-car darkcolor"></i> Vikhroli to Pune Cab Services</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-Innova-Crysta-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Innova Crysta Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pimpri-Chinchwad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pimpri Chinchwad Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune One Way Cab</Link>
<Link className="mx-md-2 d-block" to="/Andheri-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Andheri to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Bandra-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Bandra to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Santacruz-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Santacruz to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-Central-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Central to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Borivali-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Borivali to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Vishrantwadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Vishrantwadi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Alandi-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Alandi to Mumbai Cabs Service</Link>
<Link className="mx-md-2 d-block" to="/Boat-Club-Road-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Boat Club Road to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Ertiga-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga on Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Innova-Crysta-Outstation-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta Outstation Pune</Link>
<Link className="mx-md-2 d-block" to="/Urbania-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Tempo-Traveller-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller on Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pimpri-Chinchwad-Online-Cab-booking"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad Online Cab booking</Link>
<Link className="mx-md-2 d-block" to="/Best-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Best Cab Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-One-Way-Cabs-hire"><i className="fa fa-car darkcolor"></i> Pune to Mumbai One Way Cabs hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Nasik-Cabs-hire"><i className="fa fa-car darkcolor"></i> Pune to Nasik Cabs hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mahabaleshwar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Lonavala-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab Booking</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Cabs-hire"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cabs hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Lavasa-City-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Lavasa City Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-Airport-to-Bhimashankar-Cabs"><i className="fa fa-car darkcolor"></i> Pune Airport to Bhimashankar Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Indore-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Indore Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Konkan-Darshan-Cabs-hire"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cabs hire</Link>

<Link className="mx-md-2 d-block" to="/Outstation-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Outstation Cab Service Pune</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Panchgani-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cab Booking</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Nagpur-Cab-hire"><i className="fa fa-car darkcolor"></i> Pune to Nagpur Cab hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Cab-hire"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ajanta-Ellora-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Ajanta Ellora Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Urbania-on-rent"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Urbania on rent</Link>

              </div>
            </div>










            {/* Newsletter Widget */}
            <div className="col-12 col-md-3">
              <div className="footer_widget footer_newsletter_widget">
              
                <h4 className="footer_widget_title">Services</h4>
<Link className="mx-md-2 d-block" to="/Panvel-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Panvel to Pune Cab</Link>

<Link className="mx-md-2 d-block" to="/Innova-Crysta-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta on Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Ertiga-Cab-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga Cab Booking in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-Outstation-Cab"><i className="fa fa-car darkcolor"></i> Pune Outstation Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Cabs</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Dadar-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Dadar to Pune Cab</Link>
<Link className="mx-md-2 d-block" to="/Wagholi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Wagholi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-Outstation-Cab-Hire"><i className="fa fa-car darkcolor"></i> Pune Outstation Cab Hire</Link>
<Link className="mx-md-2 d-block" to="/Outstation-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Outstation Cab Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Cabs-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Cabs Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Konkan-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Konkan Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ashtavinayak-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Cab</Link>



<Link className="mx-md-2 d-block" to="/Kolhapur-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Kolhapur to Pune Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Gujarat-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Hyderabad-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ahilyanagar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Ahilyanagar Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Sambhajinagar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Sambhajinagar Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Dhule-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Dhule Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Jalgaon-Cab"><i className="fa fa-car darkcolor"></i> Pune to Jalgaon Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-Latur-Cabs"><i className="fa fa-car darkcolor"></i> Pune Latur Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Darshan Cab</Link>
<Link className="mx-md-2 d-block" to="/Mumbai-to-Shirdi-Return-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Shirdi Return Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Satara-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Satara Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Sangli-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Sangli Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Solapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Solapur Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Tuljapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tuljapur Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ujjain-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Ujjain Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Innova-Crysta-Cab-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta Cab On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Outstation-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Outstation Cab Booking Pune</Link>


<br/>

<Link className="mx-md-2 d-block" to="/Pune-to-Ahmednagar-Cab">
  <i className="fa fa-car darkcolor"></i> Pune to Ahmednagar Cab
</Link>



<Link className="mx-md-2 d-block" to="/Pune-to-Jalna-Cab">
  <i className="fa fa-car darkcolor"></i> Pune to Jalna Cab
</Link>

<Link className="mx-md-2 d-block" to="/Mumbai-to-Shirdi-Cabs">
  <i className="fa fa-car darkcolor"></i> Mumbai to Shirdi Cabs
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Bhimashankar-Cab">
  <i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab
</Link>

<Link className="mx-md-2 d-block" to="/Pune-Airport-Cab">
  <i className="fa fa-car darkcolor"></i> Pune Airport Cab
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Outstation-Cabs">
  <i className="fa fa-car darkcolor"></i> Pune to Outstation Cabs
</Link>



<Link className="mx-md-2 d-block" to="/Pune-to-Rajasthan-Cab">
  <i className="fa fa-car darkcolor"></i> Pune to Rajasthan Cab
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Telangana-Cab">
  <i className="fa fa-car darkcolor"></i> Pune to Telangana Cab
</Link>

<Link className="mx-md-2 d-block" to="/Corporate-Cab-Services-in-Pune">
  <i className="fa fa-car darkcolor"></i> Corporate Cab Services in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Ayodhya-Tour-Package">
  <i className="fa fa-car darkcolor"></i> Pune to Ayodhya Tour Package
</Link>

<Link className="mx-md-2 d-block" to="/Navi-Mumbai-Airport-Cab">
  <i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab
</Link>

<Link className="mx-md-2 d-block" to="/Cheap-Cab-Service-in-Pune">
  <i className="fa fa-car darkcolor"></i> Cheap Cab Service in Pune
</Link>

              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom-outer">
          <div className="copyright">
             <p className="copyright-text text-dark">
              All Rights Reserved &copy;  <span className="darkcolorrr">Sai Trupti cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
          </div>
  
        </div>
      </div>
    </footer>
  );
};

export default Footer;
